'use client';
import React from 'react';
import clsx from 'clsx';
import { usePlan } from '@/context/PlanContext';

/**
 * Simplified version — shows current plan status without toggle.
 */
export default function PlanSwitch({ className = '', size = 'sm', showLabel = true }) {
  const { isPro } = usePlan();

  if (!showLabel) return null;

  return (
    <div className={clsx('inline-flex items-center', className)}>
      <span
        className={clsx(
          'text-xs font-medium px-2 py-0.5 rounded-full',
          isPro
            ? 'bg-[#f1731c]/10 text-[#f1731c]'
            : 'bg-zinc-200/60 text-zinc-700 dark:bg-zinc-700/60 dark:text-zinc-300'
        )}
      >
        {isPro ? 'Pro Plan' : 'Free Plan'}
      </span>
    </div>
  );
}

/** Floating version removed (no toggle shown) */
export function PlanSwitchFloating() {
  return null;
}
